export const getHandlers = state => state.handlerSelector.handler.nodes;
export const getCheckedHandlers = state => state.handlerSelector.handler.checkedHandlers;

export const getSelectedHandlers = state =>
  (state.handlerSelector.handler.nodes || []).filter(node =>
    getCheckedHandlers(state).includes(node.value));

export const getCheckedHandlerLabels = state =>
  getSelectedHandlers(state).map(node => node.label);

export const getHandlerIsLoading = state => state.handlerSelector.handler.isLoading;
